import React from "react";
import * as Styles from "./styles/NavigationStepStyles";
import { TradeInAemLabel } from "../../../../utils/labels";
import { useTradeInAemSelector } from "../../../../redux/store";
import { IconWrapper } from "../../../../../common-deprecated/styles/v2/toyota/globals/IconWrapper";
import Icon from "../../../../../common-deprecated/styles/v2/toyota/globals/Icon";
import useTradeInAemNavigationItemsDesktop from "../../../../hooks/useTradeInAemNavigationItemsDesktop";

const TradeInAemNavigationItemsDesktop = (): JSX.Element => {
    const currentStep = useTradeInAemSelector((state) => state.tradeInAemNav.step);
    const { activeNavigationSteps, showPreviousArrow, showNextArrow, clickPreviousArrow, clickNextArrow } =
        useTradeInAemNavigationItemsDesktop();

    return (
        <Styles.Wrapper>
            {showPreviousArrow && (
                <Styles.ArrowButton>
                    <IconWrapper onClick={clickPreviousArrow}>
                        <Icon variant="chevronLeft" />
                    </IconWrapper>
                </Styles.ArrowButton>
            )}
            {activeNavigationSteps.map((step, index) => {
                // We need to show a left separator on the first item, but only if we are past the first 'page' of nav steps.
                const pastFirstPage = index === 0 && step.stepCount > 1;
                return (
                    <Styles.Link onClick={step.onClick} key={step.label}>
                        <Styles.Step isActive={currentStep === step.type} showLeftSeparator={pastFirstPage}>
                            <Styles.Badge className="build-badge" isActive={currentStep === step.type}>
                                0{step.stepCount}
                            </Styles.Badge>
                            <TradeInAemLabel label={step.label} />
                        </Styles.Step>
                    </Styles.Link>
                );
            })}
            {showNextArrow && (
                <Styles.ArrowButton>
                    <IconWrapper onClick={clickNextArrow}>
                        <Icon variant="chevronRight" />
                    </IconWrapper>
                </Styles.ArrowButton>
            )}
        </Styles.Wrapper>
    );
};

export default TradeInAemNavigationItemsDesktop;
